export default __webpack_public_path__ + "static/media/maker2.97891109.png";